/**
 * Created by rafael on 07.03.17.
 */
import {
  INCREMENT,
  SEARCHBOX_STATUS,
  TOGGLE_SEARCHBOX_STATUS,
} from '../constants';

export const incrementBounceCounter = (value = 1) =>
  ({
    type: INCREMENT,
    value,
  });
export const setSearchboxStatus = visibility =>
  ({
    type: SEARCHBOX_STATUS,
    visibility,
  });
export const toggleSearchboxStatus = () =>
  ({
    type: TOGGLE_SEARCHBOX_STATUS,
  });



// WEBPACK FOOTER //
// src/actions/style.js